<div class="table-scroll">
  <table class="freq-table">
    <tbody>
      <tr>
        <th class="label-cell">{{ params().label ?? 'Value' }}</th>
        @for (entry of entries(); track entry.value) {
          <td
            class="data-cell"
            [style.background-color]="entry.color"
            (mouseenter)="onHover(entry.value)"
            (mouseleave)="onHover(null)"
          >
            {{ entry.displayValue }}
          </td>
        }
      </tr>
      <tr>
        <th class="label-cell">Frequency</th>
        @for (entry of entries(); track entry.value) {
          <td
            class="data-cell"
            [style.background-color]="entry.color"
            (mouseenter)="onHover(entry.value)"
            (mouseleave)="onHover(null)"
          >
            {{ entry.frequency }}
          </td>
        }
      </tr>
    </tbody>
  </table>
</div>
